export enum ActionTypes {
  SetLoading = 'Coterie/SetLoading',
  SetSelectedQuote = 'Coterie/SetSelectedQuote',
  SetPlanToCard = 'Coterie/SetCard',
  SetPaymentOption = 'Coterie/SetPaymentOption',
  SetPurchasedPolicyDetails = 'Coterie/SetPurchasedPolicyDetails',
}
